import script from "./FooterHeks.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterHeks.vue?vue&type=script&setup=true&lang=js"

import "./FooterHeks.vue?vue&type=style&index=0&id=62d7d737&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d7d737"]])

export default __exports__